export default {
  title: 'Sensibilité extra-financière',
  sustainable: {
    title: 'SFDR',
    subtitle: 'Réglementation SFDR',
    help: `
      <p>Investir dans des entreprises contribuant positivement à des enjeux de développement durable.</p>
      <p>La Réglementation SFDR (« Sustainable Finance Disclosure Regulation »)* permet de distinguer les produits qui contribuent à des objectifs de développement durable&nbsp;:</p>
      <ul class="list-disc">
        <li>Environnementaux (développement d'énergies renouvelables)</li>
        <li>Sociaux (aide à l'emploi)</li>
        <li>Qui appliquent des pratiques de bonne Gouvernance (parité hommes-femmes)</li>
      </ul>
      <p>* Règlement sur la publication d'information en matière de finance durable</p>
    `,
  },
  legend: {
    riskLevel: 'Votre patrimoine',
    investorProfile: 'Vos préférences',
  },
  step: {
    neutral: 'Neutre',
    moderate: 'Impliqué',
    significant: 'Responsable',
    high: 'Engagé',
  },
  impacts: {
    title: 'Principales incidences négatives',
    subtitle: "Mon placement n'aggrave pas :",
    help: `
      <p>L'identification des principales incidences négatives permet aux investisseurs de limiter l'impact de leur épargne sur :</p>
      <ul class="list-disc">
        <li>Les émissions de gaz à effet de serre et la consommation énergétique</li>
        <li>Les atteintes à la biodiversité</li>
        <li>Les émissions polluantes dans l'eau</li>
        <li>La génération de déchets dangereux</li>
        <li>Le non-respect des droits humains et normes sociales internationales (droit du travail, encadrement des armes controversées…)</li>
        <li>L'inégalité femmes hommes (rémunération, diversité des genres dans les conseils d'administration…)</li>
      </ul>
    `,

    label: {
      biodiversity: "L'atteinte à la biodiversité",
      genderEquality: 'Inégalités femmes hommes',
      greenhouseGases: 'Les émissions de gaz à effet de serre',
      hazardousWaste: 'La génération des déchets dangereux',
      humanRights:
        'Le non-respect des droits humains et des normes sociales internationales',
      waterPollution: "Les émissions polluantes dans l'eau",
    },
  },
  environment: {
    title: 'Taxonomie',
    subtitle: 'Réglementation Taxonomie',
    help: `
      <p>Ce système de classification établit des critères pour classer les activités économiques qui contribuent significativement à l'un des six objectifs environnementaux et climatiques spécifiques identifiés par l'Union Européenne tels que l'atténuation du changement climatique ou encore la protection des ressources aquatiques et marines. Il permet donc :</p>
      <ul class="list-disc">
        <li>d'identifier les activités « vertes »</li>
        <li>de mesurer leur part dans l'activité d'une entreprise et, par extension, la part « verte » des produits financiers »</li>
      </ul>
    `,
  },
}
